import React from "react";
import { Tabs } from "antd";
import { useTranslation } from "react-i18next";
import CodePieChart from "./CodePieChart";
import CodeCloud from "./CodeCloud";

const TabsView = ({ projectId }: any) => {
  const { t } = useTranslation("docProcessingCodes");
  const items = [
    {
      key: "1",
      label: t("tabsView.pieChart"),
      children: <CodePieChart projectId={projectId} />,
    },
    {
      key: "2",
      label: t("tabsView.codeCloud"),
      children: <CodeCloud />,
    },
  ];

  return <Tabs defaultActiveKey="1" items={items} />;
};

export default TabsView;
